export default __webpack_public_path__ + "static/media/through-user-insights-template.4f29f58e.pptx";